import { render, staticRenderFns } from "./ExtrusionPanel.vue?vue&type=template&id=7edf94fd&scoped=true&"
import script from "./ExtrusionPanel.vue?vue&type=script&lang=js&"
export * from "./ExtrusionPanel.vue?vue&type=script&lang=js&"
import style0 from "./ExtrusionPanel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ExtrusionPanel.vue?vue&type=style&index=1&id=7edf94fd&lang=scss&scoped=true&"
import style2 from "./ExtrusionPanel.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edf94fd",
  null
  
)

export default component.exports